import { Tooltip } from '@crazyegginc/hatch';

export function getCriteriaTooltipContent(criteria) {
  return `You can change the ${criteria.label} condition here.`;
}

export function getValueTooltipContent(criteria) {
  return `You can add another ${criteria.tooltipLabel ?? criteria.label.toLowerCase()} here.`;
}

export function ConditionTooltip({
  children,
  content,
  criteria,
  type = 'value',
  show,
  onDismiss,
  skiddingPercent = '80',
}) {
  if (!show) {
    return children;
  }

  const tooltipContent =
    content ||
    (criteria ? (type === 'criteria' ? getCriteriaTooltipContent(criteria) : getValueTooltipContent(criteria)) : '');

  return (
    <Tooltip
      containerStyle={{ zIndex: 100000 }}
      hover={false}
      placement="bottom"
      skiddingPercent={skiddingPercent}
      arrowSkiddingPercent="20"
      offset="0"
      onDismiss={onDismiss}
      tooltipContent={<div className="w-[130px] text-left">{tooltipContent}</div>}
    >
      {children}
    </Tooltip>
  );
}
